module.exports = __webpack_public_path__ + "static/zenklai-6b29e8589cae34c2f79de5ffd7e7698a.png";